export * from './tyrehotelcheckout.component';



// WEBPACK FOOTER //
// ./src/app/landingpages/tyrehotelcheckout/index.ts